<template>
  <div>
    <v-row justify="space-between">
      <h3 class="title white--text">AI Prompts</h3>
    </v-row>
    <a-card
      v-for="item in lists"
      :key="item.name"
      class="hover"
      @click.native="$router.push({ name: 'admin_ai_prompts_edit', params: { name: item.name } })"
    >
      {{ item.label }}
    </a-card>
  </div>
</template>

<script>
import AI_PROMPTS_CONFIG from "@/config/AI_PROMPTS_CONFIG";
export default {
  data() {
    return {
      lists: Object.keys(AI_PROMPTS_CONFIG).reduce((arr, key) => {
        arr.push({
          label: AI_PROMPTS_CONFIG[key].label,
          name: AI_PROMPTS_CONFIG[key].name,
        });
        return arr;
      }, []),
    };
  },
};
</script>
